import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { UtilityBillSummary } from 'brain-data/model/utility-bill-summary.model';
import { Observable } from 'rxjs';
import { DateService } from 'shared/services/utils/date/date.service';
import { UtilityBillUploadEvent } from '../../model/utility-bill-upload-event';
import {
  UtilityBillInboxImportResponse,
  UtilityBillInboxItem,
  UtilityBillInboxManualRequest,
} from '../../model/utility-bill-inbox';

export const UTILITIES_BILLS_URL = `${environment.apiBaseAdminUrl}/utilityBills`;

@Injectable({
  providedIn: 'root',
})
export class UtilityBillsService {
  constructor(private http: HttpClient, private dateService: DateService) {}

  getUtilityBillsUploadEvents(billingYear: string, utilityTypes: string[]) {
    const params = new HttpParams({ fromObject: { billingYear, utilityTypes } });
    return this.http.get<UtilityBillUploadEvent[]>(`${UTILITIES_BILLS_URL}/upload/events`, { params });
  }

  uploadUtilityBill(month: string, year: string, utilityType: string, file?: File): Observable<HttpEvent<UtilityBillSummary>> {
    const formData: FormData = new FormData();
    formData.append('file', file || new Blob(), file?.name);
    formData.append('utilityType', utilityType);
    formData.append('billingDate', this.dateService.getDateFromMonthAndYear(month, year).toISOString());

    // reportProgress + observe:'events' streams UploadProgress events (loaded/total bytes) so the UI
    // can show a real upload progress bar instead of an indeterminate "please wait".
    return this.http.post<UtilityBillSummary>(`${UTILITIES_BILLS_URL}/upload`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  getInbox(tab?: 'inbox' | 'system'): Observable<UtilityBillInboxItem[]> {
    let params = new HttpParams();
    if (tab) {
      params = params.set('tab', tab);
    }
    return this.http.get<UtilityBillInboxItem[]>(`${UTILITIES_BILLS_URL}/inbox`, { params });
  }

  getInboxProviders(): Observable<string[]> {
    return this.http.get<string[]>(`${UTILITIES_BILLS_URL}/inbox/providers`);
  }

  importInboxFiles(files: File[], category: 'UTILITY' | 'STEAM' = 'UTILITY'): Observable<UtilityBillInboxImportResponse> {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file, file.name));
    formData.append('category', category);
    return this.http.post<UtilityBillInboxImportResponse>(`${UTILITIES_BILLS_URL}/inbox/import`, formData);
  }

  createManualInboxBill(request: UtilityBillInboxManualRequest): Observable<UtilityBillInboxItem> {
    return this.http.post<UtilityBillInboxItem>(`${UTILITIES_BILLS_URL}/inbox/manual`, request);
  }

  downloadUtilityBillFile(fileName: string, utilityType: string): Observable<Blob> {
    const params = new HttpParams()
      .append('fileName', fileName)
      .append('utilityType', utilityType);
    return this.http.get(
      `${UTILITIES_BILLS_URL}:download`,
      {
        headers: {}, responseType: 'blob', params,
      });
  }
}
